import { EMPTY_FUNCTION } from '../../../../constants/common'
import { QA_NAME_CONFIRMATION_MINIMIZED_CLOSE } from '../../../../constants/qa'

import { MINIMIZABLE_MODAL_REPLACE_CONFIRMATION } from './useMinimizableModal.constants'

export function getReplaceConfirmation({ displacedEntry, onSubmit }) {
  const { actionButtonsProps, description, qaName } =
    displacedEntry?.replaceConfirmation ??
    MINIMIZABLE_MODAL_REPLACE_CONFIRMATION

  return {
    actionButtonsProps,
    description,
    qaName,
    onCancel: EMPTY_FUNCTION,
    onSubmit,
  }
}

export function getCloseConfirmation({ closeConfirmation, onSubmit }) {
  if (closeConfirmation) {
    return {
      Component: closeConfirmation.Component,
      onCancel: EMPTY_FUNCTION,
      onSubmit: (...args) => {
        closeConfirmation.onSubmit?.(...args)
        onSubmit()
      },
    }
  }

  return {
    qaName: QA_NAME_CONFIRMATION_MINIMIZED_CLOSE,
    onCancel: EMPTY_FUNCTION,
    onSubmit,
  }
}
